import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, change, reduxForm } from 'redux-form';
import { Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import {
  isRequired,
  validateEndDate,
  validateNumber,
} from '../../../../utils/validators';
import Select from '../../../common/forms/select/Select';
import { ACTIVITY_STATUS } from '../../../../config/constants';
import FormFooter from '../../../common/forms/FormFooter';
import { enumToSelectOptions } from '../../../../utils/enum';
import MechanicSelect from '../../../common/forms/select/MechanicSelect';
import LocationSelect from '../../../common/forms/select/LocationSelect';
import { optionPropTypes } from '../../../common/forms/select/SelectPropTypes';
import { datePropTypes } from '../../../common/forms/input/InputPropTypes';
import { DATE_TIME_FORMAT } from '../../../../config/locale';
import { tzDiff } from '../../../../utils/date';

const validateMyEndDate = (value, allValues) =>
  validateEndDate(value, allValues.startDate);

const ExecutionRegistrationForm = ({
  handleSubmit,
  initialValues,
  dispatchChange,
  disabledStatus,
}) => {
  let statusRef;
  let extensionFactorRef;
  let mechanicsRef;

  useEffect(() => {
    if (!disabledStatus) statusRef.focus();
    else mechanicsRef.focus();
  }, []);

  const [extensionFactorRequired, setExtensionFactorRequired] = useState(false);
  const [startDate, setStartDate] = useState(initialValues.startDate);
  const [endDate, setEndDate] = useState(initialValues.endDate);

  const onCalculateWorkingHours = ({ startDateSelected, endDateSelected }) => {
    let hours = tzDiff({
      startDate: startDateSelected,
      endDate: endDateSelected,
      unit: 'hours',
    });
    if (hours > 8) hours = 8;
    if (hours < 0) hours = 0;

    dispatchChange('ExecutionRegistrationForm', 'workingHour', hours);
  };

  const onChangeStatus = (option) => {
    dispatchChange('ExecutionRegistrationForm', 'extensionFactor', null);
    setExtensionFactorRequired(option.value === ACTIVITY_STATUS.EXTENDED.value);
    if (option.value === ACTIVITY_STATUS.EXTENDED.value)
      extensionFactorRef.focus();
    if (option.value === ACTIVITY_STATUS.DONE.value && mechanicsRef.focus)
      mechanicsRef.focus();
  };

  const onChangeStartDate = (e, value) => {
    setStartDate(value);
    onCalculateWorkingHours({
      startDateSelected: value,
      endDateSelected: endDate,
    });
  };

  const onChangeEndDate = (e, value) => {
    setEndDate(value);
    onCalculateWorkingHours({
      startDateSelected: startDate,
      endDateSelected: value,
    });
  };

  const validateExtensionFactor = [validateNumber];
  if (extensionFactorRequired) validateExtensionFactor.push(isRequired);

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Estado" required>
          <Field
            name="status"
            component={Select}
            options={enumToSelectOptions(ACTIVITY_STATUS).splice(1, 2)}
            onChange={onChangeStatus}
            validate={[isRequired]}
            isClereable={false}
            setFieldToBeFocused={(input) => {
              statusRef = input;
            }}
            isDisabled={disabledStatus}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="KM a Agregar" required={extensionFactorRequired}>
          <Field
            name="extensionFactor"
            component={TextInput}
            type="text"
            placeholder="KM a Agregar"
            validate={validateExtensionFactor}
            setFieldToBeFocused={(input) => {
              extensionFactorRef = input;
            }}
            disabled={disabledStatus}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Personal" required>
          <Field
            name="mechanics"
            component={MechanicSelect}
            isMulti
            validate={[isRequired]}
            setFieldToBeFocused={(input) => {
              mechanicsRef = input;
            }}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Fecha/Hora Inicio">
          <Field
            name="startDate"
            component={TextInput}
            type="datetime-local"
            placeholder={DATE_TIME_FORMAT}
            onChange={onChangeStartDate}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Fecha/Hora Final" required>
          <Field
            name="endDate"
            component={TextInput}
            type="datetime-local"
            placeholder={DATE_TIME_FORMAT}
            onChange={onChangeEndDate}
            validate={[isRequired, validateMyEndDate]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Horas Trabajadas">
          <Field
            name="workingHour"
            component={TextInput}
            type="text"
            placeholder="Horas Trabajadas"
            validate={[validateNumber]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Base" required>
          <Field
            name="baseLocationId"
            component={LocationSelect}
            forHomeBase
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Observaciones">
          <Field
            name="comment"
            component={TextInput}
            type="textarea"
            placeholder="Observaciones"
          />
        </FormItem>
      </FormGroup>
      <Field name="activityBusId" component={TextInput} type="hidden" />
      <FormFooter />
    </Form>
  );
};

ExecutionRegistrationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    status: optionPropTypes,
    startDate: datePropTypes,
    endDate: datePropTypes,
  }).isRequired,
  dispatchChange: PropTypes.func.isRequired,
  disabledStatus: PropTypes.bool,
};

ExecutionRegistrationForm.defaultProps = {
  disabledStatus: false,
};

const mapDispatchToProps = {
  dispatchChange: change,
};

const formComponent = reduxForm({
  form: 'ExecutionRegistrationForm',
})(ExecutionRegistrationForm);

export default connect(null, mapDispatchToProps)(formComponent);
